// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__mUh-b","messages":"Chat_messages__2p3W2","dateDivider":"Chat_dateDivider__1ST6w"};